// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PARTNUMBER_DELETE_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    partNumberResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* deletePartNumber({ payload }) {
    try {

        let QUERY = `
            mutation deletePartNumber ($id: Int!) {
                result: deletePartNumber (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(partNumberResult({ delete: data?.result }))
        } else yield put(partNumberResult({ delete: false }))

    } catch (exc) {
        yield put(partNumberResult());
        ExceptionManager(
            exc,
            "Manufacturers/.components/partNumbersTab/.components/deletePartNumber/redux/saga",
            "deletePartNumber"
        )
    }
}

function* watchMethods() {
    yield takeEvery(PARTNUMBER_DELETE_REQUEST, deletePartNumber);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}